import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "notification"]

  connect() {
    if (this.notificationTargets.length > 0) {
      this.showAll()
    }
  }

  showAll() {
    // Mostra il contenitore
    this.containerTarget.classList.remove("hidden")

    // Attiva animazioni di entrata rimuovendo opacity 0 e translate-y-2
    this.notificationTargets.forEach(el => {
      el.classList.remove("opacity-0", "translate-y-2")
      el.classList.add("opacity-100", "translate-y-0")
    })

    // Nasconde tutte dopo 5 secondi
    this.timeout = setTimeout(() => this.hideAll(), 5000)
  }

  hideAll() {
    this.notificationTargets.forEach(el => this.hideElement(el))
  }

  hide(event) {
    // Se chiamato da click, nasconde singola notifica
    const button = event.target
    const notification = button.closest('.pointer-events-auto')
    if (notification) {
      this.hideElement(notification)
    }
  }

  hideElement(el) {
    // Aggiungi classi per animazione uscita
    el.classList.remove("opacity-100", "translate-y-0")
    el.classList.add("opacity-0", "translate-y-2")
    // Al termine della transizione rimuovi l'elemento dal DOM
    // Se usi transitionend => chiamerà transitionEnd()
  }

  transitionEnd(event) {
    // Rimuove l'elemento che ha finito la transizione di uscita
    const el = event.target
    if (el.classList.contains("opacity-0")) {
      el.remove()
    }
    // Se non rimangono notifiche, nascondi contenitore
    if (this.notificationTargets.length === 0) {
      this.containerTarget.classList.add("hidden")
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
    }
  }
}
